/*
 * Automatically generated by SVGR from assets/icons/*.svg.
 * Do not edit this file or add other components to this directory.
 */
import type { SVGProps } from 'react'
export function ThermostatHeatIcon(
  props: SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      fill='none'
      viewBox='0 0 12 14'
      {...props}
    >
      <path
        fill='#FC8E28'
        d='M0 8.5q0-1.968.938-3.506T3 2.406 5.063.803L6 .25v2.475q0 .693.469 1.097a1.57 1.57 0 0 0 1.05.403q.318 0 .61-.131.29-.132.534-.432L9 3.25a6 6 0 0 1 2.175 2.184Q12 6.832 12 8.5q0 1.65-.806 3.01a6.07 6.07 0 0 1-2.119 2.146q.319-.45.497-.984t.178-1.135a3.6 3.6 0 0 0-.281-1.415 3.7 3.7 0 0 0-.806-1.19L6 6.324 3.356 8.931a3.8 3.8 0 0 0-.825 1.2 3.5 3.5 0 0 0-.281 1.406q0 .6.178 1.135.179.534.497.984A6.06 6.06 0 0 1 .806 11.51Q0 10.15 0 8.5m6-.075 1.594 1.556q.319.319.487.713.17.393.169.843 0 .92-.656 1.566A2.19 2.19 0 0 1 6 13.75a2.19 2.19 0 0 1-1.594-.647 2.12 2.12 0 0 1-.656-1.565q0-.432.169-.835.168-.404.487-.722z'
      />
    </svg>
  )
}
